/**
 * Framework-agnostic address helpers.
 *
 * These live outside GoogleMapsService because that module is `'use client'` and pulls in
 * `@googlemaps/js-api-loader` — importing it from server code (the api bundles common-components
 * source) drags a browser-only library into a Node build. Nothing here touches the Google Maps SDK.
 */

export type SimpleAddress = PrismaJson.SimpleAddress & {};

export function simpleAddressToString(address: SimpleAddress, separator = `\n`) {
	const lines = [
		address.line1.trim(),
		address.line2?.trim(),
		[address.city.trim(), address.state.trim(), address.postalCode.trim()].join(' '),
		address.country.trim(),
	];
	return lines.filter((line) => !!line).join(separator);
}
